import { render, staticRenderFns } from "./AccidentIntakeMedicationsAllergiesForm.vue?vue&type=template&id=07efd023"
import script from "./AccidentIntakeMedicationsAllergiesForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeMedicationsAllergiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports